<template>
  <div>
    <T1Tabs tabLabelType="h2">
      <T1Tab key="1" title="Przewodnik" v-if="guideDescShow" renderContent>
        <T1Descriptions :descriptionsData="descriptionsData" />
      </T1Tab>
      <T1Tab key="2" title="Mapa" v-if="hasCoords" renderContent>
        <T1Map v-if="mapCoords" :mapCoords="mapCoords" />
      </T1Tab>
      <T1Tab key="3" :title="getAZTitle()" v-if="azItemsShow" renderContent>
        <T1Descriptions :descriptionsData="aZInfoData" />
      </T1Tab>
      <T1Tab
        key="4"
        title="Informacje praktyczne"
        v-if="practicalInfoShow"
        renderContent
      >
        <T1Descriptions :descriptionsData="practicalInfoData" tableOfContents />
      </T1Tab>
    </T1Tabs>
  </div>
</template>

<script>
import * as CONFIG from "./config.js";
import T1Tabs from "./T1Tabs/T1Tabs";
import T1Tab from "./T1Tabs/T1Tab";
import T1Descriptions from "./T1TabsContent/T1Descriptions";
import T1Map from "./T1TabsContent/T1Map";

export default {
  props: {
    mapCoords: Array,
    hasCoords: Boolean,
    descriptionsData: Array,
    aZInfoData: Array,
    practicalInfoData: Array,
  },
  data: () => ({
    guideDescShow: true,
    azItemsShow: true,
    practicalInfoShow: true,
  }),
  methods: {
    getMapCoords() {
      return this.mapCoords;
    },
    getAZTitle() {
      return CONFIG.panstwo_nazwapl + " od A do Z";
    },
  },
  watch: {
    descriptionsData: function () {
      if (!this.descriptionsData.length) {
        this.guideDescShow = false;
      }
    },
    aZInfoData: function () {
      if (!this.aZInfoData.length) {
        this.azItemsShow = false;
      }
    },
    practicalInfoData: function () {
      if (!this.practicalInfoData.length) {
        this.practicalInfoShow = false;
      }
    },
  },
  components: {
    T1Tabs,
    T1Tab,
    T1Descriptions,
    T1Map,
  },
};
</script>
